import { getChainName } from '@ui/constants/chain';
import { useDataChainId } from '@ui/hooks/datachain';
import { useUniqueSortedTradePairInfos } from '@ui/hooks/trade/useTradePairInfos';
import { isFresh } from '@ui/utils/isFresh';
import { useMemo } from 'react';

import { CATEGORY_TAGS, CategoryTag } from '../constants';

export const useGetCategories = () => {
  const tradingPairs = useUniqueSortedTradePairInfos();
  const chainId = useDataChainId();

  // Filter out NEW tag if there are no newly listed pairs
  const categories = useMemo(() => {
    const currentChainCategoryTags = CATEGORY_TAGS[getChainName(chainId)];
    // const hasNewlyListed =
    //   (tradingPairs ?? []).filter((pair) => isFresh(pair.listedAt)).length > 0;
    // if (!hasNewlyListed) {
    //   return currentChainCategoryTags.filter((tag) => tag !== CategoryTag.NEW);
    // }
    return currentChainCategoryTags;
  }, [chainId, tradingPairs]);

  return categories;
};
